import { render, staticRenderFns } from "./localizationSwitcher.vue?vue&type=template&id=781d1d88&scoped=true&"
import script from "./localizationSwitcher.vue?vue&type=script&lang=js&"
export * from "./localizationSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./localizationSwitcher.vue?vue&type=style&index=0&id=781d1d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d1d88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemContent,VMenu})
